/**
 * 表示系ユーティリティ。
 *
 * - setRoot: #root に HTML をセット（画面遷移の基本）
 * - showToast: 一時的な通知（成功/警告/エラー/情報）
 * - showError: 旧 LIFF と互換のためのエラーバナー
 * - escapeHtml: ユーザー入力を innerHTML に埋める前にエスケープ
 *
 * フレームワーク非依存。テンプレートリテラルで HTML を組み立てる方針。
 */

export function setRoot(html: string): void {
  const root = document.getElementById("root");
  if (root) root.innerHTML = html;
}

export type ToastKind = "success" | "warning" | "error" | "info";

/**
 * 画面上部にトーストを出して数秒で消す。
 * 連打されても重ならないよう、表示中の同種トーストは消してから出し直す。
 */
export function showToast(text: string, kind: ToastKind = "info", durationMs = 3500): void {
  // 既存トーストを除去（重なり防止）
  document.querySelectorAll(".toast").forEach((el) => el.remove());

  const div = document.createElement("div");
  div.className = `toast toast-${kind}`;
  div.setAttribute("role", "status");
  div.textContent = text;
  document.body.appendChild(div);
  setTimeout(() => div.remove(), durationMs);
}

export function showError(message: string): void {
  showToast(message, "error", 5000);
}

/**
 * innerHTML 経由で文字列を埋め込む際の XSS 対策。
 * 顧客名・相談内容・メモなど、自由入力フィールドは必ず通すこと。
 */
export function escapeHtml(s: string | null | undefined): string {
  if (s === null || s === undefined) return "";
  return String(s)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");
}

/**
 * 改行を <br> に変換しつつ HTML エスケープ。
 * 相談内容・メモのプレビュー表示で使う。
 */
export function nl2br(s: string | null | undefined): string {
  return escapeHtml(s).replace(/\n/g, "<br>");
}
